import "../../landing.scss";
import { useHistory } from "react-router-dom";

const LandingComponent = () => {
	const history = useHistory();
	return (
		<div className="noselect landing-home landing-new-home">
			<div className={`together-landing-banner-wrap`}>
				<img
					src={`/assets/images/landing/landing-bg-1.png`}
					alt={`당영 투게더 1`}
				/>
				<div className={`together-landing-banner-title-wrap`}>
					<h1>영양제는{"\n"}당신의 영양제</h1>
					<p>쉽고 빠른 수익 창출, 차별화된 정산 서비스</p>
					<button
						className={`together-landing-banner-signup-button`}
						onClick={() => history.push(`/login`)}
					>
						{/*회원가입*/}
						로그인
						<img
							src={`/assets/images/channel/line-arrow-icon.png`}
							alt={`이미지 홈 성분별`}
						/>
					</button>
				</div>
			</div>
			<div className={`together-landing-banner-img-div`}>
				<img
					src={`/assets/images/landing/sales_image.png`}
					alt={`당영 투게더 1`}
				/>
			</div>

			{/* 당영투게더, 왜 써야 할까요? */}
			<div className={`together-landing-description-wrap`} id={`first`}>
				<div className={`together-landing-description-each`}>
					<div className={`together-landing-description-title-div`}>
						<h4>당영투게더, 왜 써야 할까요?</h4>
						<h3>쉽고 간편한 수익 프로세스</h3>
					</div>
					<div className={`landing-image-group-wrap`}>
						<div className={`landing-image-shadow-wrap`}>
							<div className={`image-div`}>
								<img
									src="/assets/images/landing/together3-1.png"
									alt={"수익프로세스 0"}
									style={{ paddingTop: "0.5em" }}
								/>
							</div>
							<h6>수수료 높은 상품 선택</h6>
						</div>
						<div className={`landing-image-shadow-wrap`}>
							<div className={`image-div`}>
								<img
									src="/assets/images/landing/together3-2.png"
									alt={"수익프로세스 1"}
									style={{ paddingTop: "0.5em" }}
								/>
							</div>
							<h6>링크 복사 후 공유</h6>
						</div>
						<div className={`landing-image-shadow-wrap`}>
							<div className={`image-div`}>
								<img
									src="/assets/images/landing/together3-3.png"
									alt={"수익프로세스 2"}
									style={{ paddingTop: "0.5em" }}
								/>
							</div>
							<h6>상품 수수료 정산</h6>
						</div>
					</div>
				</div>
			</div>

			{/* 당영투게더, 어떻게 시작할까요? */}
			<div className={`together-landing-description-wrap`} id={`second`}>
				<div className={`together-landing-description-each`}>
					<div className={`together-landing-description-title-div`}>
						<h4 style={{ textAlign: "right" }}>
							당영투게더, 어떻게 시작할까요?
						</h4>
						<h3 style={{ textAlign: "right" }}>복잡한 절차없이 간단한 가입</h3>
					</div>
					<div className={`landing-image-group-wrap`}>
						<div className={`landing-image-shadow-wrap`}>
							<div className={`image-div`}>
								<img
									src="/assets/images/landing/together7-1.png"
									alt={"가입 0"}
								/>
							</div>
							<h5>회원가입</h5>
							<p>당영투게더 홈페이지에서{"\n"}회원가입을 진행해주세요</p>
						</div>
						<div className={`landing-image-shadow-wrap`}>
							<div className={`image-div`}>
								<img
									src="/assets/images/landing/together7-2.png"
									alt={"가입 1"}
								/>
							</div>
							<h5>활동신청</h5>
							<p>
								당영투게더를 함께 활동 할{"\n"}
								페이지 정보를 입력해주세요
							</p>
						</div>
						<div className={`landing-image-shadow-wrap`}>
							<div className={`image-div`}>
								<img
									src="/assets/images/landing/together7-3.png"
									alt={"가입 2"}
								/>
							</div>
							<h5>가입승인</h5>
							<p>
								가입승인이 되면 공식적으로{"\n"}
								당영투게더 활동이 가능합니다
							</p>
						</div>
					</div>
				</div>
			</div>

			{/* 실시간으로 본인의 수익 확인 가능 */}
			<div className={`together-landing-description-wrap`} id={`third`}>
				<div className={`together-landing-description-each`}>
					<div className={`together-landing-description-title-div`}>
						<h4 style={{ textAlign: "center" }}>
							실시간으로 본인의 수익 확인 가능
						</h4>
						<h3 style={{ textAlign: "center" }}>
							가시화 된 투명한 정산 시스템
						</h3>
					</div>
					<div className={`landing-image-group-wrap`}>
						<div
							className={`landing-image-shadow-wrap`}
							style={{
								width: "100%",
							}}
						>
							<div className={`image-div`} id={`full`}>
								<img
									src="/assets/images/landing/together5.png"
									alt={"정산 0"}
									style={{ objectFit: "contain" }}
								/>
							</div>
						</div>
					</div>
					<p className={`landing-description-footer-font pc`}>
						매달 말일 구매 수익을 정산해{"\n"}
						다음달 15일에 등록된 계좌로 수수료가 자동 지급됩니다
					</p>
					<p className={`landing-description-footer-font mobile`}>
						매달 말일 구매 수익을 정산해 다음달 15일에{"\n"}등록된 계좌로
						수수료가 자동 지급됩니다
					</p>
				</div>
			</div>
		</div>
	);
};

export default LandingComponent;
